// extracted by mini-css-extract-plugin
export default {"TextAreaComponent":"TextArea_TextAreaComponent__hSlQ8","TextAreaComponent__Styles":"TextArea_TextAreaComponent__Styles__KJ-1a","label":"TextArea_label__KLYej"};